module.exports = __webpack_public_path__ + "static/media/ValeraSlide.61d618c8.jpg";